module.exports = " <div class=Content> <form @submit.prevent=login> <input v-model=user.email name=email id=email type=text> <br> <input v-model=user.password name=password id=password type=text> <br> <input type=submit> </form> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/views/LoginView.vue
// module id = 524
// module chunks = 1